import React from 'react';
import { ClassNames } from 'storybook/internal/theming';
import { cn } from '@/lib/utils';
import Button from '@/shared/components/ui/Button';

interface BottomActionProps {
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  textButton?: string;
  /** Short note shown above the button */
  note?: string;
}

const BottomAction = ({
  className,
  disabled = false,
  onClick,
  textButton,
  note,
}: BottomActionProps) => {
  return (
    <div
      className={cn(
        'fixed inset-x-0 bottom-0 z-10 mx-auto flex w-full flex-col items-center gap-3 bg-white px-6 py-3 lg:max-w-[60%] md:max-w-[80%]',
        className
      )}
    >
      {note && <p className="body2 w-full text-text-grey">{note}</p>}
      <div className="flex w-full flex-1">
        <Button
          type="button"
          onClick={onClick}
          disabled={disabled}
          className="title1medium btn-fill-blue flex-1 px-8"
        >
          {textButton}
        </Button>
      </div>
    </div>
  );
};

export default BottomAction;
